module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "timeout": 10000,
      "error": _vm.message.meta.error,
      "primary": _vm.message.meta.success,
      "info": _vm.message.meta.info,
      "warning": _vm.message.meta.warning,
      "multi-line": ""
    },
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [(_vm.message.meta.error) ? _c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("error")]) : _c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("info")]), _vm._v("\n  " + _vm._s(_vm.message.message) + "\n  "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Inchide mesajul'
      }),
      expression: "{ html: 'Inchide mesajul' }",
      arg: "left"
    }],
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Goleste mesageria.'
      }),
      expression: "{ html: 'Goleste mesageria.' }",
      arg: "left"
    }],
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearAll($event)
      }
    }
  }, [_c('v-icon', [_vm._v("clear_all")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e5696e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Snackbar.vue
// module id = 602
// module chunks = 12